import {useContext, useEffect, useMemo} from "react"
import {SavedMatch, useApiCall, useApiEndpoint} from "../../../../lib/src/api";
import {useInterval} from "../../../../lib/src/util/useInterval";
import {ConfigInterface} from "../../../../lib/src/config";
import {TelephoneMatchesContext} from "../context/TelephoneMatchesContext";

export function useMatches() {
  return useContext(TelephoneMatchesContext)
}